// extracted by mini-css-extract-plugin
module.exports = {"DefaultLayout":"DefaultLayout","App__Main":"App__Main"};